import { render } from "./PoliticaView.vue?vue&type=template&id=22a5f024"
import script from "./PoliticaView.vue?vue&type=script&lang=js"
export * from "./PoliticaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__